export const numericASC = (a, b) => a - b;

export const numericDESC = (a, b) => b - a;
